
export default function PerformanceSection() {
  const achievements = [
    {
      number: '500+',
      label: '顧客企業数',
      description: '様々な業種の企業様にサービスを提供'
    },
    {
      number: '25+',
      label: '年の実績',
      description: '長年の経験と信頼の実績'
    },
    {
      number: '98%',
      label: '顧客満足度',
      description: 'お客様から高い評価をいただいています'
    },
    {
      number: '24h',
      label: '対応時間',
      description: '緊急時も迅速にサポート'
    }
  ];

  const testimonials = [
    {
      name: '田中 太郎',
      company: '株式会社ABC商事',
      role: '代表取締役',
      comment: '複雑な税務処理も丁寧に説明していただき、安心してお任せできます。経営面でのアドバイスも的確で、事業拡大に大きく貢献していただいています。',
      image: 'https://public.readdy.ai/ai/img_res/5e59674d820d172dde4f6c16807ef713.jpg'
    },
    {
      name: '佐藤 花子',
      company: '有限会社XYZ製作所',
      role: '経理部長',
      comment: '毎月の経理業務を代行していただき、本業に集中できるようになりました。レスポンスも早く、質問にも親切に答えていただけます。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20portrait%2C%20middle-aged%20female%20executive%20in%20business%20attire%2C%20friendly%20professional%20smile%2C%20office%20environment%2C%20high%20quality%20headshot%20photography%2C%20corporate%20appearance&width=100&height=100&seq=testimonial-2&orientation=squarish'
    },
    {
      name: '山田 次郎',
      company: '個人事業主',
      role: 'フリーランス',
      comment: '個人事業主として独立する際に、設立から税務まで一貫してサポートしていただきました。おかげで安心して事業をスタートできました。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20freelancer%20portrait%2C%20young%20male%20entrepreneur%20in%20casual%20business%20attire%2C%20confident%20expression%2C%20modern%20workspace%20background%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=testimonial-3&orientation=squarish'
    }
  ];

  return (
    <section id="performance" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            実績
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            数多くのお客様にご信頼いただいている実績をご紹介します
          </p>
        </div>

        {/* 数値実績 */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mb-12 sm:mb-16 md:mb-20 px-2">
          {achievements.map((achievement, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-600 mb-1 sm:mb-2">
                {achievement.number}
              </div>
              <div className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2 break-words">
                {achievement.label}
              </div>
              <div className="text-xs sm:text-sm text-gray-600 break-words px-1">
                {achievement.description}
              </div>
            </div>
          ))}
        </div>

        {/* お客様の声 */}
        <div className="px-2">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 text-center mb-8 sm:mb-10 md:mb-12">
            お客様の声
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg p-5 sm:p-6 shadow-lg">
                <div className="flex items-center mb-3 sm:mb-4">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover object-top mr-3 sm:mr-4 flex-shrink-0"
                  />
                  <div className="min-w-0">
                    <div className="text-sm sm:text-base font-semibold text-gray-900 break-words">{testimonial.name}</div>
                    <div className="text-xs sm:text-sm text-gray-600 break-words">{testimonial.company}</div>
                    <div className="text-xs text-gray-500 break-words">{testimonial.role}</div>
                  </div>
                </div>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed break-words">
                  "{testimonial.comment}"
                </p>
                <div className="flex mt-3 sm:mt-4">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-yellow-400"></i>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
